<template>
  <div class="m-portlet__head">
    <div class="m-portlet__head-progress">
      <!-- here can place a progress bar-->
    </div>
    <div class="m-portlet__head-wrapper">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">{{label}}</h3>
          <img src="../../../assets/image/add.png" @click="Save" title="加入常用操作" style="width:27px;padding-top:3px;padding-left:10px;cursor:pointer;" />
        </div>
        <span v-if="label2 != '' && label2 != null" style="margin-left: 50px;" class="m--font-warning">{{label2}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchTitle',
  props: {
    label: {
      type: String
    },
    label2: {
      type: String
    },
    url: {
      type: String
    }
  },
  methods: {
    Save: function () {
      var args = {
        token: sessionStorage.getItem('token'),
        userid: sessionStorage.getItem('userid'),
        menuname: this.label,
        menuurl: '/main' + this.url
      }
      this.$http.post(this.$utils.Url.zpgl + '/api/APIPower/AddUserMenu', args)
        .then(res => {
          console.log(res.data)
          if (res.data.Code === 0) {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$router.push('/main' + this.url)
          } else {
            this.$message({
              message: res.data.Msg + '，' + res.data.Error,
              type: 'error'
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '添加失败',
            type: 'error'
          })
        })
    }
  }
}
</script>

<style scoped="scoped">
  .el-table--medium td, .el-table--medium th {
      padding: 6px 0;
  }
  .el-table .cell {
      line-height: 36px;
  }
</style>
